import FormattedMessage from 'I18n/components/FormattedMessage';
import { ListsIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function BulkManageAccessButton({
  canAssignUsersAndTeams,
  isProductReadOnly,
  onClick
}) {
  if (!canAssignUsersAndTeams || isProductReadOnly) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Link, {
    "data-test-id": "manage-access-link",
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(ListsIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.table.bulkActions.assignTeams"
    })]
  });
}
export default BulkManageAccessButton;